import React from "react";
import { CircularProgress } from "@mui/material";
import './style.roundloader.scss'

export const RoundLoader = () : React.ReactElement => <div className='loader'> <CircularProgress  /> </div>